// src/json/servicesOverview.json
export const servicesOverviewConcreteRestoration = {
    eyebrow: "OUR CONCRETE RESTORATION",
    titleHighlight: "SERVICES INCLUDE:",
    items: [
        {
            title: "Structural Concrete Repairs",
            description: "Reinforcing weakened or damaged columns, beams, balconies, and foundations to restore load-bearing capacity."
        },
        {
            title: "Crack Repair & Injection",
            description: "Sealing cracks and fractures using epoxy and polyurethane injection techniques to prevent water infiltration and further deterioration."
        },
        {
            title: "Concrete Resurfacing & Overlays",
            description: "Applying high-performance overlays and coatings to restore smooth, durable, and weather-resistant surfaces."
        },
        {
            title: "Spall & Corrosion Repair",
            description: "Addressing concrete spalling, rusting rebar, and exposed reinforcement to prevent long-term structural damage."
        },
        {
            title: "Protective Coatings & Waterproofing",
            description: "Using high-build coatings, sealers, and waterproof membranes to enhance durability and resistance to moisture, chemicals, and environmental factors."
        }
    ],
    imageUrl: "/assets/imgs/services/8concreteRestoration/servicesOverview/fondo.jpg",
    button: {
        text: "Request a Quote",
        url: "/quote"
    }
};  